import { AdministrationRemindersPage } from "../pages/administration";

const AdministrationRemindersRoutes = {
    path: 'reminders',
    roles: [],
    element: AdministrationRemindersPage
};

export default AdministrationRemindersRoutes;